function selectValues(element) {
  const { _id, name } = element;
  return { value: _id, label: name };
}

export const collegeSelection = (array) => array?.map(selectValues);
